import { Box, Button, DialogActions, DialogContent, TextField, Autocomplete } from '@mui/material'
import { CustomTextField } from 'Components/CustomTextField'
import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { UTILISATION } from 'utils/constants'
import { convertToMuiDate } from 'utils/helpers'

export const UtilisationForm = ({
  utilisationType,
  formErrors,
  handleSubmitData,
  handleClose,
  activeDocument,
  typeDeChauffage,
  Norme,
  typeChauffeEau,
  nombreHabitant,
  contacts,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm({
    defaultValues: {
      valeur: '',
      purchase_price: '',
      date_of_purchase: '',
      date_of_sale: '',
      responsable: '',
      financement: '',
      type_de_commerce: '',
      bailleur: '',
      owner_name: '',
      date_of_entry: '',
      loyer: '',
      charges: '',
      locataire: '',
      type_de_chauffage: '',
      norme: '',
      type_chauffe_eau: '',
      nombre_habitant: '',
    },
  })

  useEffect(() => {
    if (Object.keys(activeDocument).length > 0) {
      const {
        locatif_immobilier,
        professional_immobilier,
        property_location_immobilier,
        property_residence,
      } = activeDocument
      if (locatif_immobilier) {
        if (locatif_immobilier.date_of_sale === '' || locatif_immobilier.date_of_sale === null) {
          reset({
            ...locatif_immobilier,
            date_of_purchase: convertToMuiDate(locatif_immobilier.date_of_purchase),
          })
        } else {
          reset({
            ...locatif_immobilier,
            date_of_purchase: convertToMuiDate(locatif_immobilier.date_of_purchase),
            date_of_sale: convertToMuiDate(locatif_immobilier.date_of_sale),
          })
        }
      } else if (professional_immobilier) {
        if (
          professional_immobilier.date_of_sale === '' ||
          professional_immobilier.date_of_sale === null
        ) {
          reset({
            ...professional_immobilier,
            date_of_purchase: convertToMuiDate(professional_immobilier.date_of_purchase),
          })
        } else {
          reset({
            ...professional_immobilier,
            date_of_purchase: convertToMuiDate(professional_immobilier.date_of_purchase),
            date_of_sale: convertToMuiDate(professional_immobilier.date_of_sale),
          })
        }
      } else if (property_location_immobilier) {
        reset({
          ...property_location_immobilier,
          date_of_entry: convertToMuiDate(property_location_immobilier.date_of_entry),
        })
      } else if (property_residence) {
        if (property_residence.date_of_sale === '' || property_residence.date_of_sale === null) {
          reset({
            ...property_residence,
            date_of_purchase: convertToMuiDate(property_residence.date_of_purchase),
          })
        } else {
          reset({
            ...property_residence,
            date_of_purchase: convertToMuiDate(property_residence.date_of_purchase),
            date_of_sale: convertToMuiDate(property_residence.date_of_sale),
          })
        }
      }
    }
  }, [activeDocument])
  // }, [])

  const onSubmit = (data) => {
    const payload = { ...data }
    if (data.date_of_sale === '') {
      delete payload.date_of_sale
    }
    handleSubmitData(payload)
  }
  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <DialogContent>
        {(utilisationType === 'Residence propriétaire' ||
          utilisationType === 'Professionnel' ||
          utilisationType === 'Locatif') && (
          <>
            {utilisationType === 'Professionnel' && (
              <>
                <CustomTextField
                  label="Type de commerce "
                  fullWidth
                  placeholder="Enter Type de commerce "
                  register={{
                    ...register('type_de_commerce', {
                      maxLength: {
                        value: 30,
                        message: 'Type de commerce cannot be more than 30 characters',
                      },
                    }),
                  }}
                  error={(errors.type_de_commerce && true) || (formErrors.type_de_commerce && true)}
                  helperText={
                    (errors.type_de_commerce && errors.type_de_commerce.message) ||
                    formErrors.type_de_commerce
                  }
                />
              </>
            )}
            <CustomTextField
              required
              label="Valeur marché"
              fullWidth
              placeholder="Enter Valeur"
              type="number"
              register={{
                ...register('valeur', {
                  required: { value: true, message: 'Valeur is required' },
                  maxLength: { value: 9, message: 'Valeur cannot be more than 9 digits' },
                }),
              }}
              error={(errors.valeur && true) || (formErrors.valeur && true)}
              helperText={(errors.valeur && errors.valeur.message) || formErrors.valeur}
            />
            <CustomTextField
              required
              label="Prix d'acquisition"
              fullWidth
              placeholder="Enter Prix d'acquisition"
              type="number"
              register={{
                ...register('purchase_price', {
                  required: { value: true, message: "Prix d'acquisition is required" },
                  maxLength: {
                    value: 9,
                    message: "Prix d'acquisition cannot be more than 9 digits",
                  },
                }),
              }}
              error={(errors.purchase_price && true) || (formErrors.purchase_price && true)}
              helperText={
                (errors.purchase_price && errors.purchase_price.message) ||
                formErrors.purchase_price
              }
            />
            <CustomTextField
              required
              label="Date d’acquisition"
              fullWidth
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Enter Date d’acquisition"
              register={{
                ...register('date_of_purchase', {
                  required: { value: true, message: 'Date d’acquisition  is required' },
                }),
              }}
              error={(errors.date_of_purchase && true) || (formErrors.date_of_purchase && true)}
              helperText={
                (errors.date_of_purchase && errors.date_of_purchase.message) ||
                formErrors.date_of_purchase
              }
            />
            <CustomTextField
              label="Date de vente"
              fullWidth
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Enter Date de vente "
              register={{
                ...register('date_of_sale'),
              }}
              error={(errors.date_of_sale && true) || (formErrors.date_of_sale && true)}
              helperText={
                (errors.date_of_sale && errors.date_of_sale.message) || formErrors.date_of_sale
              }
            />
            {/* <CustomTextField
              label="Responsable"
              fullWidth
              placeholder="Enter responsable"
              register={{
                ...register('responsable', {
                  maxLength: {
                    value: 30,
                    message: 'Responsable cannot be more than 30 characters',
                  },
                }),
              }}
              error={(errors.responsable && true) || (formErrors.responsable && true)}
              helperText={
                (errors.responsable && errors.responsable.message) || formErrors.responsable
              }
            /> */}
            {/* <Controller
              name={'responsable'}
              control={control}
           
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Autocomplete
                  disablePortal
                  sx={{ marginTop: '7px' }}
                  options={contacts}
                  getOptionLabel={(option) =>
                    option?.label ?? contacts.find(({ id }) => id === option)?.label ?? ''
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  {...field}
                  renderInput={(params) => (
                    <TextField required {...params} size="small" label="Responsable" />
                  )}
                  onChange={(_event, data) => field.onChange(data?.id || '')}
                />
              )}
            /> */}
            {/* <CustomTextField
              label="Financement"
              fullWidth
              placeholder="Enter financement"
              register={{
                ...register('financement', {
                  maxLength: { value: 5, message: 'Nom cannot be more than 5 characters' },
                }),
              }}
              error={(errors.financement && true) || (formErrors.financement && true)}
              helperText={
                (errors.financement && errors.financement.message) || formErrors.financement
              }
            /> */}
            {utilisationType === 'Locatif' && (
              <>
                <CustomTextField
                  required
                  label="Loyer"
                  fullWidth
                  placeholder="Enter loyer"
                  type="number"
                  register={{
                    ...register('loyer', {
                      required: { value: true, message: 'Loyer is required' },
                      maxLength: { value: 9, message: 'Loyer cannot be more than 9 digits' },
                    }),
                  }}
                  error={(errors.loyer && true) || (formErrors.loyer && true)}
                  helperText={(errors.loyer && errors.loyer.message) || formErrors.loyer}
                />
                {/* <CustomTextField
                label="Locataire"
                fullWidth
                placeholder="Enter Locataire"
                register={{
                  ...register('locataire', {
                    required: { value: true, message: 'Locataire is required' },
                    maxLength: { value: 30, message: 'Locataire cannot be more than 30 characters' },
                  }),
                }}
                error={(errors.locataire && true) || (formErrors.locataire && true)}
                helperText={
                  (errors.locataire && errors.locataire.message) || formErrors.locataire
                }
              /> */}
                {/* <Controller
                  name={'locataire'}
                  control={control}
                  // defaultValue={'Maison'}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      disablePortal
                      sx={{ marginTop: '7px' }}
                      options={contacts}
                      getOptionLabel={(option) =>
                        option?.label ?? contacts.find(({ id }) => id === option)?.label ?? ''
                      }
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      {...field}
                      renderInput={(params) => (
                        <TextField required {...params} size="small" label="Locataire" />
                      )}
                      onChange={(_event, data) => field.onChange(data?.id || '')}
                    />
                  )}
                /> */}
              </>
            )}
          </>
        )}
        {utilisationType === '2' && (
          <>
            <CustomTextField
              required
              label="Valeur marché"
              fullWidth
              placeholder="Enter Valeur"
              type="number"
              register={{
                ...register('valeur', {
                  required: { value: true, message: 'Valeur is required' },
                  maxLength: { value: 9, message: 'Valeur cannot be more than 9 digits' },
                }),
              }}
              error={(errors.nom && true) || (formErrors.nom && true)}
              helperText={(errors.nom && errors.nom.message) || formErrors.nom}
            />
            <CustomTextField
              required
              label="Prix d'acquisition"
              fullWidth
              placeholder="Enter Prix d'acquisition"
              register={{
                ...register('purchase_price', {
                  required: { value: true, message: "Prix d'acquisition is required" },
                  maxLength: {
                    value: 9,
                    message: "Prix d'acquisition cannot be more than 9 digits",
                  },
                }),
              }}
              error={(errors.purchase_price && true) || (formErrors.purchase_price && true)}
              helperText={
                (errors.purchase_price && errors.purchase_price.message) ||
                formErrors.purchase_price
              }
            />
            <CustomTextField
              required
              label="Date d’acquisition"
              fullWidth
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Enter Date d’acquisition"
              register={{
                ...register('date_of_purchase', {
                  required: { value: true, message: 'Date d’acquisition  is required' },
                }),
              }}
              error={(errors.date_of_purchase && true) || (formErrors.date_of_purchase && true)}
              helperText={
                (errors.date_of_purchase && errors.date_of_purchase.message) ||
                formErrors.date_of_purchase
              }
            />
            <CustomTextField
              label="Date de vente"
              fullWidth
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Enter Date de vente "
              register={{
                ...register('date_of_sale'),
              }}
              error={(errors.date_of_sale && true) || (formErrors.date_of_sale && true)}
              helperText={
                (errors.date_of_sale && errors.date_of_sale.message) || formErrors.date_of_sale
              }
            />
            <CustomTextField
              label="Responsable"
              fullWidth
              placeholder="Enter responsable"
              register={{
                ...register('responsable', {
                  maxLength: {
                    value: 30,
                    message: 'Responsable cannot be more than 30 characters',
                  },
                }),
              }}
              error={(errors.responsable && true) || (formErrors.responsable && true)}
              helperText={
                (errors.responsable && errors.responsable.message) || formErrors.responsable
              }
            />
            <CustomTextField
              label="Financement"
              fullWidth
              placeholder="Enter financement"
              register={{
                ...register('financement', {
                  maxLength: { value: 5, message: 'Nom cannot be more than 5 characters' },
                }),
              }}
              error={(errors.financement && true) || (formErrors.financement && true)}
              helperText={
                (errors.financement && errors.financement.message) || formErrors.financement
              }
            />
          </>
        )}
        {utilisationType === '3' && (
          <CustomTextField
            label="Type de commerce "
            fullWidth
            placeholder="Enter Type de commerce "
            register={{
              ...register('type_de_commerce', {
                maxLength: {
                  value: 30,
                  message: 'Type de commerce cannot be more than 30 characters',
                },
              }),
            }}
            error={(errors.type_de_commerce && true) || (formErrors.type_de_commerce && true)}
            helperText={
              (errors.type_de_commerce && errors.type_de_commerce.message) ||
              formErrors.type_de_commerce
            }
          />
        )}

        {(utilisationType === '2' || utilisationType === '4') && (
          <CustomTextField
            required
            label="Loyer"
            fullWidth
            type="number"
            placeholder="Enter Loyer"
            register={{
              ...register('loyer', {
                required: { value: true, message: 'Loyer is required' },
                maxLength: { value: 9, message: 'Loyer cannot be more than 9 digits' },
              }),
            }}
            error={(errors.loyer && true) || (formErrors.loyer && true)}
            helperText={(errors.loyer && errors.loyer.message) || formErrors.loyer}
          />
        )}
        {utilisationType === '2' && (
          <>
            <CustomTextField
              required
              label="Bailleur"
              fullWidth
              placeholder="Enter bailleur"
              register={{
                ...register('bailleur', {
                  required: { value: true, message: 'Bailleur is required' },
                  maxLength: { value: 30, message: 'Bailleur cannot be more than 30 characters' },
                }),
              }}
              error={(errors.bailleur && true) || (formErrors.bailleur && true)}
              helperText={(errors.bailleur && errors.bailleur.message) || formErrors.bailleur}
            />
            <CustomTextField
              label="Propriétaire"
              fullWidth
              placeholder="Enter Propriétaire"
              register={{
                ...register('owner_name', {
                  maxLength: {
                    value: 30,
                    message: 'Propriétaire cannot be more than 30 characters',
                  },
                }),
              }}
              error={(errors.owner_name && true) || (formErrors.owner_name && true)}
              helperText={(errors.owner_name && errors.owner_name.message) || formErrors.owner_name}
            />
            <CustomTextField
              label="Charges"
              fullWidth
              type="number"
              placeholder="Enter Charges"
              register={{
                ...register('charges', {
                  maxLength: { value: 9, message: 'Charges cannot be more than 9 digits' },
                }),
              }}
              error={(errors.charges && true) || (formErrors.charges && true)}
              helperText={(errors.charges && errors.charges.message) || formErrors.charges}
            />
            <CustomTextField
              required
              label="Date d'entrée "
              fullWidth
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Enter Date d'entrée "
              register={{
                ...register('date_of_entry', {
                  required: { value: true, message: "Date d'entrée  is required" },
                  maxLength: {
                    value: 30,
                    message: "Date d'entrée  cannot be more than 30 characters",
                  },
                }),
              }}
              error={(errors.date_of_entry && true) || (formErrors.date_of_entry && true)}
              helperText={
                (errors.date_of_entry && errors.date_of_entry.message) || formErrors.date_of_entry
              }
            />
          </>
        )}
        {utilisationType === '4' && (
          <>
            <CustomTextField
              required
              label="Locataire"
              fullWidth
              placeholder="Enter locataire"
              register={{
                ...register('locataire', {
                  required: { value: true, message: 'locataire is required' },
                  maxLength: { value: 30, message: 'locataire cannot be more than 30 characters' },
                }),
              }}
              error={(errors.locataire && true) || (formErrors.locataire && true)}
              helperText={(errors.locataire && errors.locataire.message) || formErrors.locataire}
            />
          </>
        )}
        {utilisationType === 'Location' && (
          <>
            {/* <CustomTextField
              required
              label="Bailleur"
              fullWidth
              placeholder="Enter Bailleur"
              register={{
                ...register('bailleur', {
                  required: { value: true, message: 'Bailleur is required' },
                  maxLength: { value: 30, message: 'Bailleur cannot be more than 30 characters' },
                }),
              }}
              error={(errors.bailleur && true) || (formErrors.bailleur && true)}
              helperText={(errors.bailleur && errors.bailleur.message) || formErrors.bailleur}
            /> */}
            {/* <Controller
              name={'bailleur'}
              control={control}
              // defaultValue={'Maison'}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Autocomplete
                  disablePortal
                  sx={{ marginTop: '7px' }}
                  options={contacts}
                  getOptionLabel={(option) =>
                    option?.label ?? contacts.find(({ id }) => id === option)?.label ?? ''
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  {...field}
                  renderInput={(params) => (
                    <TextField required {...params} size="small" label="Bailleur" />
                  )}
                  onChange={(_event, data) => field.onChange(data?.id || '')}
                />
              )}
            />
            <Controller
              name={'owner_name'}
              control={control}
              // defaultValue={'Maison'}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Autocomplete
                  disablePortal
                  sx={{ marginTop: '7px' }}
                  options={contacts}
                  getOptionLabel={(option) =>
                    option?.label ?? contacts.find(({ id }) => id === option)?.label ?? ''
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  {...field}
                  renderInput={(params) => (
                    <TextField required {...params} size="small" label="Propriétaire" />
                  )}
                  onChange={(_event, data) => field.onChange(data?.id || '')}
                />
              )}
            /> */}
            {/* <CustomTextField
              required
              label="Propriétaire"
              fullWidth
              placeholder="Enter Propriétaire"
              register={{
                ...register('owner_name', {
                  required: { value: true, message: 'Propriétaire is required' },
                  maxLength: { value: 30, message: 'Propriétaire cannot be more than 30 characters' },
                }),
              }}
              error={(errors.owner_name && true) || (formErrors.owner_name && true)}
              helperText={(errors.owner_name && errors.owner_name.message) || formErrors.owner_name}
            /> */}
            <CustomTextField
              required
              label="Date d'entrée "
              fullWidth
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              placeholder="Enter Date d'entrée "
              register={{
                ...register('date_of_entry', {
                  required: { value: true, message: "Date d'entrée  is required" },
                  maxLength: {
                    value: 30,
                    message: "Date d'entrée  cannot be more than 30 characters",
                  },
                }),
              }}
              error={(errors.date_of_entry && true) || (formErrors.date_of_entry && true)}
              helperText={
                (errors.date_of_entry && errors.date_of_entry.message) || formErrors.date_of_entry
              }
            />
            <CustomTextField
              required
              label="Loyer"
              fullWidth
              type="number"
              placeholder="Enter Loyer"
              register={{
                ...register('loyer', {
                  required: { value: true, message: 'Loyer is required' },
                  maxLength: { value: 9, message: 'Loyer cannot be more than 9 digits' },
                }),
              }}
              error={(errors.loyer && true) || (formErrors.loyer && true)}
              helperText={(errors.loyer && errors.loyer.message) || formErrors.loyer}
            />
            <CustomTextField
              required
              label="Charges"
              fullWidth
              type="number"
              placeholder="Enter Charges"
              register={{
                ...register('charges', {
                  required: { value: true, message: 'Charges is required' },
                  maxLength: { value: 9, message: 'Charges cannot be more than 9 digits' },
                }),
              }}
              error={(errors.charges && true) || (formErrors.charges && true)}
              helperText={(errors.charges && errors.charges.message) || formErrors.charges}
            />
          </>
        )}
        {(utilisationType === 'Residence propriétaire' || utilisationType === 'Location') && (
          <>
            <Controller
              name={'type_de_chauffage'}
              control={control}
              // defaultValue={'Maison'}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Autocomplete
                  disablePortal
                  sx={{ marginTop: '7px' }}
                  options={typeDeChauffage}
                  getOptionLabel={(option) =>
                    option?.label ?? typeDeChauffage.find(({ id }) => id === option)?.label ?? ''
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  {...field}
                  renderInput={(params) => (
                    <TextField required {...params} size="small" label="Type de chauffage" />
                  )}
                  onChange={(_event, data) => field.onChange(data?.id || '')}
                />
              )}
            />
            <Controller
              name={'norme'}
              control={control}
              // defaultValue={'Maison'}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Autocomplete
                  disablePortal
                  sx={{ marginTop: '7px' }}
                  options={Norme}
                  getOptionLabel={(option) =>
                    option?.label ?? Norme.find(({ id }) => id === option)?.label ?? ''
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  {...field}
                  renderInput={(params) => (
                    <TextField required {...params} size="small" label="Norme" />
                  )}
                  onChange={(_event, data) => field.onChange(data?.id || '')}
                />
              )}
            />
            <Controller
              name={'type_chauffe_eau'}
              control={control}
              // defaultValue={'Maison'}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Autocomplete
                  disablePortal
                  sx={{ marginTop: '7px' }}
                  options={typeChauffeEau}
                  getOptionLabel={(option) =>
                    option?.label ?? typeChauffeEau.find(({ id }) => id === option)?.label ?? ''
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  {...field}
                  renderInput={(params) => (
                    <TextField required {...params} size="small" label="Type chauffe eau" />
                  )}
                  onChange={(_event, data) => field.onChange(data?.id || '')}
                />
              )}
            />
            <Controller
              name={'nombre_habitant'}
              control={control}
              // defaultValue={''}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Autocomplete
                  disablePortal
                  sx={{ marginTop: '7px' }}
                  options={nombreHabitant}
                  getOptionLabel={(option) =>
                    option?.label ?? nombreHabitant.find(({ id }) => id === option)?.label ?? ''
                  }
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  {...field}
                  renderInput={(params) => (
                    <TextField required {...params} size="small" label="Nombre habitant" />
                  )}
                  onChange={(_event, data) => field.onChange(data?.id || '')}
                />
              )}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button type="submit">Valider</Button>
        <Button onClick={() => handleClose(0)}>Annuler</Button>
      </DialogActions>
    </Box>
  )
}
